import { useEffect, useState } from 'react';
import api from '../wrapper/API';

const IDLE = { key: null, data: null, loading: false, failed: false };

/**
 * Impact preview for the popups of the player page (POST /ParticipantGroupMembership/Preview,
 * POST /Role/Preview). Sends `body` debounced whenever its content changes; `null` = idle (popup closed
 * or form incomplete), so nothing is requested while nobody looks at it. Only the latest response is
 * kept — fast input changes never show numbers of an older request. While a new request runs the
 * previous result stays visible (no flicker), `loading` marks it as being refreshed.
 */
export default function usePreviewRequest(url, body, delay = 250) {
  const key = body ? JSON.stringify(body) : null;
  const [state, setState] = useState(IDLE);

  useEffect(() => {
    if (!key) {
      setState(IDLE);
      return undefined;
    }
    let alive = true;
    setState(prev => ({ ...prev, key, loading: true, failed: false }));
    const timer = setTimeout(() => {
      api.post(url, JSON.parse(key))
        .then(res => { if (alive) setState({ key, data: res.data ?? null, loading: false, failed: false }); })
        .catch(() => { if (alive) setState({ key, data: null, loading: false, failed: true }); });
    }, delay);
    return () => {
      alive = false;
      clearTimeout(timer);
    };
  }, [url, key, delay]);

  return state;
}
